export default "__VITE_ASSET__e742b276__"